import { CorporateModules } from '../modules';
import { ExecutiveAlerts } from './ExecutiveAlerts';
import { ExecutiveMetricGrid } from './ExecutiveMetricGrid';
import { ExecutiveQuickActions } from './ExecutiveQuickActions';
import { ExecutiveRecentActivity } from './ExecutiveRecentActivity';
import { ExecutiveStatusPanel } from './ExecutiveStatusPanel';

export const DashboardExecutive = () => (
  <div
    className="arx-executive-dashboard"
    data-aranox-component="executive-dashboard"
  >
    <header className="arx-executive-hero">
      <div>
        <span className="arx-executive-hero__eyebrow">
          ARANOX CONTROL CENTER
        </span>
        <h1>Dashboard Executivo</h1>
        <p>
          Visão corporativa consolidada de ativos, serviços, operações,
          governança e evolução da Plataforma Digital ARANOX.
        </p>
      </div>

      <div className="arx-executive-hero__context" aria-label="Contexto atual">
        <span>Organização</span>
        <strong>ARANOX</strong>
        <small>Ambiente corporativo</small>
      </div>
    </header>

    <ExecutiveMetricGrid />

    <div className="arx-executive-dashboard__two-columns">
      <ExecutiveStatusPanel />
      <ExecutiveAlerts />
    </div>

    <ExecutiveRecentActivity />
    <CorporateModules />
    <ExecutiveQuickActions />
  </div>
);
